"use strict"; // Adds Responsive Embeds to all iframe, objects and video tags

jQuery(document).ready(function() {
    jQuery('.wp-block-table').each(function() {
        jQuery(this).wrap("<div class='table-responsive'/>");
        jQuery(this).addClass('table table-striped')
    });
});